import React from 'react';
import { motion } from 'framer-motion';

const tones = [
  { id: 'default', color: '#FFDE34', label: '預設' },
  { id: '1f3fb', color: '#F7D7C4', label: '淺膚色' },
  { id: '1f3fc', color: '#D4A181', label: '中淺膚色' },
  { id: '1f3fd', color: '#AF7E57', label: '中膚色' },
  { id: '1f3fe', color: '#7C4B30', label: '中深膚色' },
  { id: '1f3ff', color: '#3A2314', label: '深膚色' },
];

const SkinTonePicker = ({ currentTone, onToneChange }) => {
  return (
    <div className="flex items-center gap-2 p-1.5 bg-slate-100/80 backdrop-blur-md rounded-2xl border border-slate-200 shadow-inner">
      {tones.map((tone) => (
        <motion.button
          key={tone.id}
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.9 }}
          onClick={() => onToneChange(tone.id)}
          className={`w-7 h-7 rounded-full border-2 transition-all ${
            currentTone === tone.id ? 'border-indigo-500 scale-110 shadow-md' : 'border-transparent shadow-sm'
          }`}
          style={{ backgroundColor: tone.color }}
          title={tone.label}
        />
      ))}
    </div>
  );
};

export default SkinTonePicker;